export default __webpack_public_path__ + "static/media/Roboter-Katze-Fisch.ba94747f.png";